import { render, staticRenderFns } from "./MakeOrderPage.vue?vue&type=template&id=3cd1cc5f&scoped=true"
import script from "./MakeOrderPage.vue?vue&type=script&lang=js"
export * from "./MakeOrderPage.vue?vue&type=script&lang=js"
import style0 from "./MakeOrderPage.vue?vue&type=style&index=0&id=3cd1cc5f&prod&scoped=true&lang=css"
import style1 from "./MakeOrderPage.vue?vue&type=style&index=1&id=3cd1cc5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1cc5f",
  null
  
)

export default component.exports